import React, {Fragment, useEffect, useState} from "react";
import {Slider} from "@blueprintjs/core";
import LabelWithInfo from "../../../components/LabelWithInfo/LabelWithInfo";

const {forwardRef, useImperativeHandle} = React;

const FeeSlider = forwardRef((props, ref) => {

    const STEP_SIZE = 500;
    let minValue = Math.ceil(props.min / STEP_SIZE) * STEP_SIZE;
    let maxValue = Math.ceil(props.max / STEP_SIZE) * STEP_SIZE;

    const [sliderValue, setSliderValue] = useState(props.defaultValue);
    const [inputValue, setInputValue] = useState(props.defaultValue);

    const computePercentage = (val) =>
        props.vehiclePrice && props.vehiclePrice > 0
            ? Math.round(val / props.vehiclePrice * 100)
            : null;

    const [percentageInputValue, setPercentageInputValue] = useState(
        () => computePercentage(props.defaultValue)
    );

    useImperativeHandle(ref, () => ({
        getStepSize() {
            return STEP_SIZE;
        }
    }));

    useEffect(() => {
        setInputValue(sliderValue);
        setPercentageInputValue(computePercentage(sliderValue));
    }, [sliderValue]);

    useEffect(() => setSliderValue(prevValue => validatedValue(prevValue)), [props.min, props.max]);

    useEffect(() => {
        if (!props.vehiclePrice || props.vehiclePrice <= 0 || percentageInputValue === '' || percentageInputValue == null) {
            return;
        }

        const newValue = Math.round(props.vehiclePrice * percentageInputValue / 100);
        const validated = validatedValue(newValue);
        const rounded = Math.round(validated / STEP_SIZE) * STEP_SIZE;
        setSliderValue(rounded);
        setInputValue(rounded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.brutto]);

    const validatedValue = (value) => {
        if (value < minValue) return minValue;
        if (value > maxValue) return maxValue;
        return value;
    }

    const sliderValueChangeHandler = (value) => setSliderValue(Math.round(validatedValue(value) / STEP_SIZE) * STEP_SIZE);
    const inputValueChangeHandler = (event) => setInputValue(parseInt(event.target.value));
    const inputBlurHandler = () => {
        const validatedInputValue = validatedValue(inputValue);
        setSliderValue(validatedInputValue);
        setInputValue(validatedInputValue);
        props.onChange(validatedInputValue);
    }
    const sliderReleaseHandler = (value) => {
        props.onChange(value);
    }

    const percentageChangeHandler = (e) => {
        const raw = e.target.value.replace(/\D/g, '');
        setPercentageInputValue(raw === '' ? '' : parseInt(raw, 10));
    };

    const percentageBlurHandler = () => {
        if (!props.vehiclePrice || props.vehiclePrice <= 0) return;
        const pct = percentageInputValue === '' ? 0 : Number(percentageInputValue);
        const newValue = Math.round(props.vehiclePrice * pct / 100);
        const validated = validatedValue(newValue);
        const rounded = Math.round(validated / STEP_SIZE) * STEP_SIZE;
        setSliderValue(rounded);
        setInputValue(rounded);
        props.onChange(rounded);
    };

    const showPercentage = props.vehiclePrice != null && props.vehiclePrice > 0;

    return (
        <Fragment>
            <div className="calc__fee-header">
                <p className="calc__form-label">
                    <LabelWithInfo infoCode={props.infoCode} strongTitle={true}/>
                </p>
                <div className="calc__fee-input">
                    {showPercentage && (
                        <>
                            <input
                                type="text"
                                inputMode="numeric"
                                className="calc__fee-percent-input"
                                value={percentageInputValue ?? ''}
                                onChange={percentageChangeHandler}
                                onBlur={percentageBlurHandler}
                                onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); }}
                            />
                            <span className="calc__fee-percent-label">%</span>
                        </>
                    )}
                    <input type="number" value={inputValue} min={minValue}
                           max={maxValue} onChange={inputValueChangeHandler} onBlur={inputBlurHandler}
                           onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); }}/>
                    <span className="calc__fee-unit">
                        zł {props.isCreditCalculation ? "brutto" : props.brutto ? "brutto" : "netto"}
                    </span>
                </div>
            </div>
            <Slider
                min={minValue}
                max={maxValue}
                stepSize={STEP_SIZE}
                labelRenderer={false}
                value={validatedValue(sliderValue)}
                className="go-slider"
                onChange={sliderValueChangeHandler}
                onRelease={sliderReleaseHandler}
            />
        </Fragment>
    );
});

export default FeeSlider;
